import React from 'react';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

export const RenderSelectField = ({input, name, label, meta: {touched, error}, items, ...custom}) =>
  <FormControl margin="normal" fullWidth>
    <InputLabel htmlFor={name}>{label}</InputLabel>
    <Select
      {...input}
      {...custom}
      error={!!(touched && error)}
      autoWidth
    >
      <MenuItem value="">
      </MenuItem>
      {(items || []).map(({value, name}, index) => value ?
        <MenuItem key={`${value}-${index}`} value={value}>{name}</MenuItem> : null)}
    </Select>
  </FormControl>;

